var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningCircleSolidPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9043 8.5C14.9043 11.8137 12.218 14.5 8.9043 14.5C5.59059 14.5 2.9043 11.8137 2.9043 8.5C2.9043 5.18629 5.59059 2.5 8.9043 2.5C12.218 2.5 14.9043 5.18629 14.9043 8.5ZM8.9043 4.5C9.27249 4.5 9.57096 4.79848 9.57096 5.16667V9.83333C9.57096 10.2015 9.27249 10.5 8.9043 10.5C8.53611 10.5 8.23763 10.2015 8.23763 9.83333L8.23763 5.16667C8.23763 4.79848 8.53611 4.5 8.9043 4.5ZM8.07096 11.6667C8.07096 12.1269 8.44406 12.5 8.9043 12.5C9.36453 12.5 9.73763 12.1269 9.73763 11.6667C9.73763 11.2064 9.36453 10.8333 8.9043 10.8333C8.44406 10.8333 8.07096 11.2064 8.07096 11.6667Z",
    fill: "#2C3891"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircleSolidPrimary);
export default __webpack_public_path__ + "static/media/warning-circle-solid-primary.daa092c27ee382d56d7caf1197f277d9.svg";
export { ForwardRef as ReactComponent };